export type PersonName = {
  firstName?: string | null;
  lastName?: string | null;
};

/**
 * Joins the first and the last name with a space, leaving out missing parts.
 * Returns `''` when there is no person yet, so a loading client renders nothing.
 *
 * @example
 * formatFullName({ firstName: 'Jana', lastName: 'Nováková' }); // 'Jana Nováková'
 */
export function formatFullName(person: PersonName | null | undefined): string {
  return [person?.firstName, person?.lastName].filter(Boolean).join(' ');
}
